import { Component } from '@angular/core';
import { OrderCheckoutResultDialogBaseComponent } from 'projects/shared/lib/components/shared/checkout/result-dialog/checkout-result-dialog-base.component';

@Component({
    selector: 'app-order-checkout-result-dialog',
    templateUrl: './order-checkout-result-dialog.component.html',
    standalone: false
})
export class OrderCheckoutResultDialogComponent extends OrderCheckoutResultDialogBaseComponent { }
